import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'profile.city.label': {
    id: 'profile.city.label',
    defaultMessage: 'City',
    description: 'The label for a city in a user profile.',
  },
  'profile.city.empty': {
    id: 'profile.city.empty',
    defaultMessage: 'Add city',
    description: "The affordance to add city to a user's profile.",
  },
  'profile.city.input.placeholder': {
    id: 'profile.city.input.placeholder',
    defaultMessage: 'Enter your city',
    description: 'Placeholder text for the city input field.',
  },
  'profile.city.placeholder': {
    id: 'profile.city.placeholder',
    defaultMessage: 'Fill in the information about your city',
    description: 'Placeholder text shown when city field is empty.',
  },
});

export default messages;
